"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.showReward = exports.showAd = void 0;
var tslib_1 = require("tslib");
var core_1 = require("@dp-instant/core");
var interfaces_1 = require("@dp-instant/interfaces");
var showAd = function (placement) { return tslib_1.__awaiter(void 0, void 0, void 0, function () { return tslib_1.__generator(this, function (_a) {
    switch (_a.label) {
        case 0: return [4, core_1.di.get(interfaces_1.TypesAds.adAction).showAd(placement)];
        case 1: return [2, _a.sent()];
    }
}); }); };
exports.showAd = showAd;
var showReward = function (placement) { return tslib_1.__awaiter(void 0, void 0, void 0, function () { return tslib_1.__generator(this, function (_a) {
    switch (_a.label) {
        case 0: return [4, core_1.di.get(interfaces_1.TypesAds.adAction).showAd(placement, true)];
        case 1: return [2, _a.sent()];
    }
}); }); };
exports.showReward = showReward;
//# sourceMappingURL=helpers.js.map